var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14C13.1569 14 14.5 12.6569 14.5 11C14.5 9.34316 13.1569 8.00002 11.5 8.00002C9.84315 8.00002 8.5 9.34316 8.5 11C8.5 12.6569 9.84315 14 11.5 14Z",
    stroke: "#482714",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.278 19H13.722C16.843 19 18.404 19 19.525 18.265C20.0087 17.948 20.4253 17.5389 20.751 17.061C21.5 15.961 21.5 14.428 21.5 11.364C21.5 8.29902 21.5 6.76702 20.751 5.66702C20.4253 5.18913 20.0087 4.78002 19.525 4.46302C18.805 3.99002 17.903 3.82102 16.522 3.76102C15.863 3.76102 15.296 3.27102 15.167 2.63602C15.0684 2.17088 14.8123 1.75405 14.4418 1.45597C14.0714 1.15788 13.6095 0.996825 13.134 1.00002H9.866C8.878 1.00002 8.027 1.68502 7.833 2.63602C7.704 3.27102 7.137 3.76102 6.478 3.76102C5.098 3.82102 4.196 3.99102 3.475 4.46302C2.99162 4.78008 2.57537 5.18919 2.25 5.66702C1.5 6.76702 1.5 8.29902 1.5 11.364C1.5 14.428 1.5 15.96 2.249 17.061C2.573 17.537 2.989 17.946 3.475 18.265C4.596 19 6.157 19 9.278 19Z",
    stroke: "#482714",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8.00002H17.5",
    stroke: "#482714",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIconBlack);
export default __webpack_public_path__ + "static/media/cameraIconBlack.009835a55e1ebc637315b4745a613cd0.svg";
export { ForwardRef as ReactComponent };